import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { createUserServiceValidationForm } from "../../utils/validationSchemas";
import TextField from "../Reusable/TextInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useState } from "react";
import APIS from "../../constant/EndPoint";
import ComboboxInput from "../Reusable/ComboboxInput";
import Modal from "../Reusable/Modal";
import PhoneNumberField from "../Reusable/PhoneNumberField";
import CreateBranchForm from "./CreateBranchForm";
const CreateUser = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    control,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(createUserServiceValidationForm),
  });
  const { handleCreate, isLoading, userProfile } = props;
  const [openBranchformPopup, setIsOpenBranchformPopup] = useState(false);
  return (
    <>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleCreate}
        setError={setError}
        buttonLabel={"Create"}
        isLoading={isLoading}
      >
        <div className={tw`grid grid-cols-2 gap-x-4 mx-4`}>
          <TextField
            label={"Username"}
            register={register("username")}
            errors={errors?.username}
          />
          <TextField
            label={"Full Name"}
            register={register("full_name")}
            errors={errors?.full_name}
          />
          <TextField
            label={"Email"}
            register={register("email")}
            errors={errors?.email}
          />
          <TextField
            label={"Alt Email"}
            register={register("alt_email")}
            errors={errors?.alt_email}
          />
          <PhoneNumberField
            control={control}
            label={"Mobile Number"}
            name={"mobile_number"}
            errors={errors?.mobile_number}
          />
          <PhoneNumberField
            control={control}
            label={"Alt Mobile Number"}
            name={"alt_mobile_number"}
            errors={errors?.alt_mobile_number}
          />
          <TextField
            label={"Address"}
            register={register("address_name")}
            errors={errors?.address_name}
          />
          <div className={tw`w-full flex justify-center gap-x-2 items-center `}>
            <div className={tw`w-full`}>
              <ComboboxInput
                url={APIS.BRANCH}
                queryKey={"branch"}
                register={register("branch")}
                errors={errors?.branch}
                name={"branch"}
                label={"Branch"}
                props={{
                  is_active: true,
                }}
                setValue={setValue}
                placeholder={"Select Branch"}
                getValues={getValues}
                clearErrors={clearErrors}
              />
            </div>
            <button
              className={tw`border px-4 p-2 relative top-[15px] `}
              type="button"
              onClick={() => setIsOpenBranchformPopup(!openBranchformPopup)}
            >
              +
            </button>
          </div>
          <TextField
            label={"Password"}
            type="password"
            register={register("password")}
            errors={errors?.password}
          />
          <TextField
            label={"Confirm Password"}
            type="password"
            register={register("confirm_password")}
            errors={errors?.password}
          />
        </div>
      </FormLayout>
      <Modal
        isOpen={openBranchformPopup}
        setIsOpen={setIsOpenBranchformPopup}
        title={"Create Branch"}
        children={
          <>
            <CreateBranchForm
              openBranchformPopup={openBranchformPopup}
              userProfile={userProfile}
              setIsOpenBranchformPopup={setIsOpenBranchformPopup}
            />
          </>
        }
      />
    </>
  );
};

export default CreateUser;
